import { atom } from "jotai";

export const selectedCompletedProjectTracksAtom = atom<{
  [key: number]: boolean;
}>({});

// derived atom that has selectedTracks in an array of ids
export const selectedTracksProjectIdsAtom = atom((get) => {
  const selectedTracks = get(selectedCompletedProjectTracksAtom);
  return Object.entries(selectedTracks)
    .filter(([_, selectedTrack]) => selectedTrack)
    .map(([id]) => Number(id));
});
